import React from "react";
import { Icon } from "@vitalsource/vstui";

const Notes = ({ fill }) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(8.888889, 4.444444)" />
        <polygon
          fill={fill}
          points="6.24338624 10.5574603 14.4973545 10.5574603 14.4973545 9.18179894 6.24338624 9.18179894"
        />
        <polygon
          fill={fill}
          points="6.24338624 14.6830688 14.4973545 14.6830688 14.4973545 13.3074074 6.24338624 13.3074074"
        />
        <path
          d="M17.2482646,0.740328042 L3.49165079,0.740328042 C1.97292063,0.740328042 0.740328042,1.97292063 0.740328042,3.49165079 L0.740328042,17.2482646 C0.740328042,18.7669947 1.97292063,19.9995873 3.49165079,19.9995873 L17.2482646,19.9995873 C18.7669947,19.9995873 19.9995873,18.7669947 19.9995873,17.2482646 L19.9995873,3.49165079 C19.9995873,1.97292063 18.7669947,0.740328042 17.2482646,0.740328042 Z M3.49165079,17.2482646 L17.2482646,17.2482646 L17.2482646,3.49165079 L3.49165079,3.49165079 L3.49165079,17.2482646 Z"
          fill={fill}
        />
        <path
          d="M11.4017037,5.98503704 C11.4017037,6.55456085 10.9394815,7.01678307 10.3699577,7.01678307 C9.80043386,7.01678307 9.33821164,6.55456085 9.33821164,5.98503704 C9.33821164,5.41551323 9.80043386,4.95329101 10.3699577,4.95329101 C10.9394815,4.95329101 11.4017037,5.41551323 11.4017037,5.98503704"
          fill={fill}
        />
      </g>
    </g>
  </Icon>
);

export default Notes;
